import { Component, OnInit } from '@angular/core';
import * as M from '../../../assets/js/materialize.js';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  Ruta;
  Header;
  constructor(private location: Location,
              private router: ActivatedRoute) { }

  ngOnInit() {
    const instances1 = M.Sidenav.init( document.querySelectorAll('.sidenav'), { draggable: true, preventScrolling: true } );
    const instances2 = M.Collapsible.init( document.querySelectorAll('.collapsible'), {} );
    this.Ruta =  this.router.snapshot.url[0].path;
    switch (this.Ruta) {
      case 'antiedad25':
        this.Header = 'ANTIEDAD + 25 AÑOS';
        break;
      case 'antiedad35':
        this.Header = 'ANTIEDAD + 35 AÑOS';
        break;
      case 'antiedad45':
        this.Header = 'ANTIEDAD +45 AÑOS';
        break;
      case 'antipigmento':
        this.Header = 'PIEL PIGMENTADA';
        break;
      case 'pielgrasaomixta':
        this.Header = 'PIEL GRASA';
        break;
      case 'bebesyniños':
        this.Header = 'BEBES Y NIÑOS';
        break;
      case 'pielsensible':
        this.Header = 'PIEL SENSIBLE';
        break;
      case 'pielhipersensible':
        this.Header = 'PIEL HIPERSENSIBLE';
        break;
      case 'pielseca':
          this.Header = 'PIEL EXTRA SECA';
          break;
      case 'pielsecaysuscomplicaciones':
          this.Header = 'PIEL SECA Y SUS COMPLICACIONES';
          break;
      case 'hidratacion':
          this.Header = 'PIEL NORMAL O MIXTA';
          break;
      default:
        this.Header = 'RUTINAS';
        break;
    }
  }
}
